import { GenericProps } from "../types";
import { Views } from "./Views";

interface Props extends GenericProps {
    Filters: React.FC<GenericProps>
}

export function Header(props: Props) {

   return <div className="flex-row">

        <Views {...props} />

        <div className="flex-1 material-form filters">
            <props.Filters {...props} />
        </div>

    </div>
}